import { filter, first } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Product } from '../interfaces/product.interface';
import { MyAccountState } from '../store/state/my-account.state';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ProductService {
    products$: Observable<Product[]> = new Subject();

    constructor(
        private myAccountStore: Store<MyAccountState>,
    ) {
        this.products$ = this.myAccountStore.select(state => state.profile).pipe(
            filter(p => Object.keys(p).length > 0),
            map(p =>  p.connectedProducts),
            first(),
        );
    }

    getProduct(id: string): Observable<Product> {
        return this.products$.pipe(
            map(products => products.find(item => item.contentId === id))
        );
    }

    /**
     * Fallback lookup used to recover legacy (Drupal) URLs whose id no longer
     * matches a Hygraph contentId. The slug is stable across the migration.
     * @param {string} slug the product slug from the URL
     * @returns {Observable<Product>} the matching product, or undefined
     */
    getProductBySlug(slug: string): Observable<Product> {
        return this.products$.pipe(
            map(products => products.find(item => item.slug === slug))
        );
    }
}
